import { observer } from "mobx-react";
import React, { useState } from "react";
import {
  TextInput,
  Button,
  useMantineTheme,
  rem,
  Modal,
  Text,
  Anchor,
  ModalTitle,
} from "@mantine/core";
import { Cubby } from "../stores/Cubby";
import { validateLightningNodeURI } from "../helpers/stringValidation";
import { MODALS } from "../helpers/constants";
import { notifications } from "@mantine/notifications";
import { TextWithInfo } from "./modals/textWithInfo";
import { TextWithInfoAndIcon } from "./dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../docs/docsIndex";
import { IconPlugConnected } from "@tabler/icons-react";

const ConnectToOtherNode = observer(({ cubby }: { cubby: Cubby }) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const theme = useMantineTheme();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.currentTarget.value;
    setValue(newValue);
    const validationError = validateLightningNodeURI(newValue);
    setError(validationError);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!error && value) {
      console.log("Submitted URI:", value);

      cubby.cubbyLife("connect_to_peer", value);

      // Disable the button and set loading state for 1 second
      setLoading(true);
      setTimeout(() => {
        cubby.setModal(null); // Close the modal after 1 second
        setLoading(false); // Reset the loading state
      }, 2000);

      // Add your actual submission logic here
    }
  };

  const makeUserMessage = () => {
    if (isThisAnOnionAddress) {
      return "Connect via Tor. 🕑 Up to 45 seconds.";
    } else {
      return "Connect via clearnet. 🕑 Up to 15 seconds.";
    }
  };

  const isThisAnOnionAddress = value.includes(".onion");

  return (
    <Modal
      opened={cubby.currentModal === MODALS.CONNECT_TO_OTHER_NODE}
      onClose={() => {
        setValue("");
        cubby.setModal(null);
      }}
      title={
        <TextWithInfoAndIcon
          text="Add Peer"
          articleSlug={ARTICLES.ADD_PEER.slug}
          icon={<IconPlugConnected size={24} />}
          cubby={cubby}
          textSize="lg"
        />
      }
    >
      <form onSubmit={handleSubmit}>
        <TextInput
          description="Input the URI"
          error={value ? error : ""}
          placeholder="0322d0e43b3d92d30ed187f4e101a9a9605c3ee5fc9721e6dac3ce3d7732fbb13e@164.92.106.32:9735"
          value={value}
          onChange={handleChange}
        />

        {value && !error && (
          <Text mt="md" size="xs" c={theme.colors.cyan[5]}>
            {makeUserMessage()}
          </Text>
        )}

        {/* Add peer button below the form */}
        <Button
          mt="md"
          type="submit"
          fullWidth
          disabled={!!error || !value || loading}
          loading={loading} // Display loading state on the button
        >
          Add Peer
        </Button>
      </form>
    </Modal>
  );
});

export default ConnectToOtherNode;
